// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();







$(document).ready(function () {
    function checkVisibility() {
        $('.fade-in-scroll').each(function () {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 1) {
                $(this).addClass('is-show');
            }
        });
    }
    checkVisibility();
    $(window).on('scroll', function () {
        checkVisibility();
    });

});




function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;
        if (currentScroll > 100) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');
        if (currentScroll <= 100) {
            header.style.transform = 'translateY(0)';
        }
        else if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
        }
        else {
            header.style.transform = 'translateY(-150%)';
        }
        lastScrollTop = currentScroll;
    });
}

headerSticky();





$(document).ready(function () {
    $('.header__country-select').on('click', function (e) {
        e.stopPropagation();
        $('.header__country-option').toggleClass('active');
    });
    $('.header__country-item').on('click', function () {
        let imgSrc = $(this).find('img').attr('src');
        let imgAlt = $(this).find('img').attr('alt');
        $('.header__country-select img')
            .attr('src', imgSrc)
            .attr('alt', imgAlt);
        $('.header__country-option').removeClass('active');
    });
    $(document).on('click', function () {
        $('.header__country-option').removeClass('active');
    });
});








$(".store-locator__top-wave , .promo-banner__top-waves, .stories-bottle__top-wave").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});
$(".store-locator__bottom-wave , .promo-banner__bottom-waves , .stories-bottle__bottom-wave").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    // rtl: true,
});




$(".gallery__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});






if ($(window).width() < 768) {
    $(".shop-categories__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}


$(document).ready(function () {
    $('.drink-styles__tab').on('click', function () {
        var tabName = $(this).attr('tab-btn');
        $('.drink-styles__tab').removeClass('active');
        $(this).addClass('active');
        $('.drink-styles__tab-item').removeClass('active');
        $('.drink-styles__tab-item[tab-content="' + tabName + '"]').addClass('active');
    });
});


// Start Promo Video Play Off


$(document).ready(function () {
    function formatTime(seconds) {
        const totalSeconds = Math.floor(seconds);
        const minutes = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;
        return minutes + ':' + (secs < 10 ? '0' : '') + secs;
    }
    $('.promo-video__item').each(function () {
        const $item = $(this);
        const video = $item.find('video')[0];
        const $timeDisplay = $item.find('.promo-video__watch-time span');
        $(video).on('timeupdate', function () {
            $timeDisplay.text(formatTime(video.currentTime));
        });
        $item.on('click', function () {
            if ($item.hasClass('is-playing')) {
                video.pause();
                video.load();
                $item.removeClass('is-playing');
                $timeDisplay.text('0:00');
            } else {
                video.play();
                $item.addClass('is-playing');
            }
        });

    });

});


// End Promo Video Play Off






$('.cart-drawer__recommended-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
});

$(document).on('click', '.cart-drawer__recommended-prev', function () {
    $(this).closest('.cart-drawer__recommended').find('.slick-slider').slick('slickPrev');
});
$(document).on('click', '.cart-drawer__recommended-next', function () {
    $(this).closest('.cart-drawer__recommended').find('.slick-slider').slick('slickNext');
});

// $('.cart-drawer__recommended-prev').click(function () {
//     $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
// });
// $('.cart-drawer__recommended-next').click(function () {
//     $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
// });





$(".header__cart").on("click", function () {
    $("body").addClass("cart-drawer-show");
})
$(document).on("click", ".cart-drawer__close", function (e) {
    $("body").removeClass("cart-drawer-show");
});
$(".overlay").on("click", function () {
    $("body").removeClass("cart-drawer-show");
})





// Start Stories Bottle Slider Only Mobile

if ($(Window).width() < 768) {
    $(".stories-bottle__slider-text-item").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.stories-bottle__slider-img-wrap'
    });
    $(".stories-bottle__slider-img-wrap").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        speed: 500,
        dots: true,
        asNavFor: '.stories-bottle__slider-text-item'
    });
}
$('.stories-bottle__left-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.stories-bottle__right-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});

// End Stories Bottle Slider Only Mobile


// Start Hotspot Tab

$(document).ready(function () {
    $('.hotspot').on('click', function () {
        var hotspotVal = $(this).attr('data-hotspot-btn');
        $('.hotspot').removeClass('active');
        $(this).addClass('active');
        $('.stories-bottle__slider-text').removeClass('active');
        $('.stories-bottle__slider-text[data-hotspot="' + hotspotVal + '"]').addClass('active');
    });

});

// End Hotspot Tab



// drink-styles modal start

$(".collection-card , .collection__btn").on("click", function () {
    $("body").addClass("modal-show");
})
$(".modal__close , .overlay").on("click", function () {
    $("body").removeClass("modal-show");
})

// drink-styles modal finish























$('.product-details__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product-details__small-items',
});
$('.product-details__small-items').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.product-details__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
    ]
});


function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();
    clearTimeout($parent.data("loadingTimeout"));
    $parent.addClass("loading");
    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);
    $parent.data("loadingTimeout", timeoutId);
}
$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});


// Start Faq ( Accordion )

$(document).ready(function () {
    $(".accordion__title.active").next(".accordion__content").show();
    $(".accordion__title").on("click", function (e) {
        e.preventDefault();
        const $this = $(this);
        const $content = $this.next(".accordion__content");
        $(".accordion__content").not($content).slideUp();
        $(".accordion__title").not($this).removeClass("active");
        $content.slideToggle();
        $this.toggleClass("active");
    });
});

// End Faq ( Accordion )







// $(document).ready(function () {
//     $('.product-collection__tab').on('click', function () {
//         var target = $(this).attr('tab-btn');
//         $('.product-collection__tab').removeClass('active');
//         $(this).addClass('active');
//         var $activeItem = $('.product-collection__tab-item.active');
//         var $targetItem = $('.product-collection__tab-item[tab-content="' + target + '"]');
//         if ($activeItem.is($targetItem)) return;
//         $activeItem.fadeOut(50, function () {
//             $(this).removeClass('active');
//             $targetItem.addClass('active').hide().fadeIn(50);
//         });
//     });
// });

$('.product-collection__tab').on('click', function (e) {
    $('.product-collection__wrapper').hide();
    $('.product-collection__inner').css('background-color', 'transparent');
    $('.product-collection__inner').css('padding-bottom', '0');
    e.preventDefault();
    var $tab = $(this);
    var target = $tab.attr('tab-btn');
    var tab_title = $tab.attr('data-title');
    var collectionUrl = $tab.attr('tab-product');

    if (!collectionUrl) return;

    // Active tab
    $('.product-collection__tab').removeClass('active');
    $tab.addClass('active');

    $('.all-products__title h2').text(tab_title);

    // Smooth scroll to shop
    // if ($(target).length) {
    //     $('html, body').animate({
    //         scrollTop: $(target).offset().top
    //     }, 600);
    // }

    // Fetch collection products
    // fetch("?section_id=main-collection-product-grid&collection=" + collectionUrl)
    // .then((res) => res.text())
    // .then((data) => {
    //   var cart__html = $(data);
    //   var render__html = $(".all-products__items", cart__html);
    //   $(".all-products__items").replaceWith(render__html);
    // });

    $.get(collectionUrl, function (response) {
        var $response = $('<div>').html(response);

        var $newProducts = $response.find('.all-products__items');
        var $productStat = $response.find('.all-products__sort-wrap');

        if ($newProducts.length) {
            $('.all-products__items ').html($newProducts.html());
        }
        if ($productStat.length) {
            $('.all-products__sort-wrap').html($productStat.html());
        }
    });
});



$('.store-locator-inp').on('keydown', function(e) {
  if (e.key === 'Enter') {
    e.preventDefault();

    var location = $(this).val().trim();

    if (location) {
      window.location.href =
        '/pages/store-locator?location=' + encodeURIComponent(location);
    } else {
      window.location.href = '/pages/store-locator';
    }
  }
});

$('.store-locator__search-btn').on('click', function(e) {
      window.location.href = '/pages/store-locator';
});






// Start  Brand Story Modal Video Play Off

$(document).ready(function () {
    $('.brand-story__btn').on('click', function () {
        var $modal = $('.brand-story__modal');
        var $iframe = $modal.find('.brand-story__iframe');
        var $closeBtn = $('.brand-story__modal-close');
        var videoSrc = $(this).data('src');   // button theke URL read
        var separator = videoSrc.indexOf('?') > -1 ? '&' : '?';
        videoSrc += separator + 'autoplay=1';
        $modal.addClass('active');
        $closeBtn.addClass('active');
        $('body').addClass('brand-story__video-modal-open');
        $iframe.attr('src', videoSrc);   // iframe-e write
    });
    $('.brand-story__modal-close, .brand-story__modal-overlay').on('click', function () {
        $('.brand-story__modal').removeClass('active');
        $('.brand-story__modal-close').removeClass('active');
        $('.brand-story__iframe').attr('src', '');
        $('body').removeClass('brand-story__video-modal-open');
    });
});
//  End Brand Story Modal Video Play Off

// Start Mobile Menu

if ($(Window).width() < 768) {
$('.header__menu').on('click', function() {
    $('.header__menu').toggleClass('active');
    $('body').toggleClass('mobile-menu-show');
});
$('.overlay, .header__cart').on('click', function() {
    $('body').removeClass('mobile-menu-show');
    $('.header__menu').removeClass('active');
});
}

$(window).on('scroll', function() {
    if ($(this).scrollTop() > 0) {
        $('body').addClass('menu-height');
    } else {
        $('body').removeClass('menu-height');
    }
});

// End Mobile Menu



const rotateItems = document.querySelectorAll(
  '.hero__badge, .drink-styles__top-left-icon'
);

window.addEventListener('scroll', () => {
  const rotation = window.scrollY * 0.10;

  rotateItems.forEach(item => {
    item.style.transform = `rotate(-${rotation}deg)`;
  });
});




const $stickyBar = $('.sticky-bar');
const productBottom = $('.product-details').offset().top + $('.product-details').outerHeight();
$(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();
    if (scrollTop > productBottom + 20) {
        $stickyBar.addClass('active');
    } else {
        $stickyBar.removeClass('active');
    }
});




$('.product-details__purchase-item > input').change(function () {
    var selected_price = $(this).attr('data-price');
    $('.atc-price').text(selected_price);
    var available = $(this).attr('available');
    if (available === 'false') {
        $('.product-details__btn-url').addClass('btn_disabled');
        $('.atc-text').text('Sold Out');
    } else {
        $('.product-details__btn-url').removeClass('btn_disabled');
        $('.atc-text').text('Add to Cart');
    }
});






